import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import RBasic from "./module/0_Basic";
import RAuthors from "./module/1_Authors";
import RJournal from "./module/2_Journal";
import RCategoryRank from "./module/3_CategoryRank";
import RCitation from "./module/4_Citation";
import RAbstract from "./module/5_Abstract";
import RFund from "./module/6_Fund";
import Rreferences from "./module/7_Rreferences";
import RAlticle from "./module/8_Article";
import RAlticle2 from "./module/9_Article2";

class ResourceContent extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
	}

	linkToList = () => {
		// this.props.history.push(BASE_PATH + "journals/");
	}

	render() {
		const record = this.props.record;
		if(Object.keys(record).length <= 0)
			return ''
		return (
			<div className="center-group">
				<RBasic record={record}/>
				<RAuthors record={record}/>
				<RJournal record={record}/>
				<RCategoryRank record={record}/>
				<RCitation record={record}/>
				<RAbstract record={record}/>
				{/*<RFund record={record} />*/}
				<Rreferences record={record}/>
				{/*<RAlticle record={record}/>*/}
				<RAlticle2 record={record}/>
			</div>
		)
	}
}

export default connect(
	(state) => ({
		record: state.resources.record ? state.resources.record : {},
		meta: state.resources.meta ? state.resources.meta : {},
	}),
	(dispatch) => ({
		// dataActions: bindActionCreators(Actions, dispatch)
	}),
)(ResourceContent)

ResourceContent.propTypes = {
	// args : PropTypes.object,
	// facet : PropTypes.object,
};
